import { COLORS, colors } from '@constants/colors';

import { ISearchFieldStyles } from './interfaces';

export const useStyles = ({ value }: ISearchFieldStyles) => ({
  input: {
    color: COLORS.WHITE,
    padding: '12px 0 16px 0',
    fontSize: '14px',
    height: '14px',
    lineHeight: 1,
    columnGap: 1,
    borderRadius: '0',
    borderBottom: 'solid 1px ' + colors.grey_200,
    background: 'none',
    svg: {
      path: {
        fill: colors.grey_200,
      },
    },
    '&.Mui-focused': {
      borderBottom: 'solid 1px ' + colors.white,
      'svg:first-of-type': {
        path: {
          fill: colors.white,
        },
      },
      '&:not(.Mui-disabled)::before': {
        borderBottom: 'none',
      },
    },
    '&::before': {
      content: "''",
      transition: 'none',
      display: 'none',
    },
    '&::after': {
      borderBottom: 'none',
    },
    '& input': {
      color: COLORS.WHITE,
      '&::placeholder': {
        fontWeight: 400,
        fontSize: 14,
        lineHeight: 1.43,
        letterSpacing: '0.25px',
        color: COLORS.WHITE_6,
        opacity: 1,
      },
    },
  },
  searchIcon: {
    width: 24,
    height: 32,
    fontSize: 16,
    color: COLORS.WHITE,
    opacity: value ? 1 : 0.6,
  },
  clearIcon: {
    fontSize: 16,
    width: 24,
    height: 32,
    color: COLORS.MEDIUM_GREY,
    cursor: 'pointer',
    '&:hover': {
      color: COLORS.WHITE,
    },
  },
});
